import { useState } from 'react';
import { useDebounce, useDeepCompareEffect } from 'react-use';

import { ServiceProvidingLocationFormBean } from '../common/serviceProvidingLocation';

import { HealthcarePracticeUpdateFormController } from './HealthcarePracticeUpdateForm.types';

const SYNCHRONIZE_DEBOUNCE_DELAY = 300;

type ServiceProvidingLocationUsingHealthcarePracticeDataSynchronizerProps = Pick<
   HealthcarePracticeUpdateFormController,
   'watch' | 'setValue'
>;

export const ServiceProvidingLocationUsingHealthcarePracticeDataSynchronizer = (
   props: ServiceProvidingLocationUsingHealthcarePracticeDataSynchronizerProps
): null => {
   const { watch, setValue } = props;
   const {
      serviceProvidingLocationsToUpdate,
      name: healthcarePracticeName,
      city,
      emailAddress,
      flat,
      house,
      phoneNumber,
      postcode,
      street,
   } = watch();

   const [synchronizedServiceProvidingLocations, setSynchronizedServiceProvidingLocations] = useState<
      ServiceProvidingLocationFormBean[] | null
   >(null);

   useDebounce(
      () => {
         setValue('serviceProvidingLocationsToUpdate', synchronizedServiceProvidingLocations, { shouldValidate: true });
      },
      SYNCHRONIZE_DEBOUNCE_DELAY,
      [synchronizedServiceProvidingLocations]
   );

   useDeepCompareEffect(() => {
      setSynchronizedServiceProvidingLocations(
         serviceProvidingLocationsToUpdate?.map((serviceProvidingLocation) => {
            if (serviceProvidingLocation.usingHealthcarePracticeDetails) {
               return {
                  usingHealthcarePracticeDetails: serviceProvidingLocation.usingHealthcarePracticeDetails,
                  locationCode: serviceProvidingLocation.locationCode,
                  city: city,
                  emailAddress: emailAddress,
                  flat: flat,
                  house: house,
                  phoneNumber: phoneNumber,
                  postcode: postcode,
                  serviceProvidingLocationName: healthcarePracticeName,
                  street: street,
                  medicalField: serviceProvidingLocation.medicalField,
               };
            }

            return serviceProvidingLocation;
         }) ?? null
      );
   }, [
      healthcarePracticeName,
      city,
      emailAddress,
      flat,
      house,
      phoneNumber,
      postcode,
      street,
      serviceProvidingLocationsToUpdate,
   ]);

   return null;
};
